import { baseUrlManagement as management } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsProjects = {
  list: `${management}/project`,
  listRoles: `${management}/project/roles`,
  create: {
    method: "POST",
    url: `${management}/project`,
  } as Endpoint,
  patch: (id: number) =>
    ({
      method: "PATCH",
      url: `${management}/project/${id}`,
    }) as Endpoint,
  delete: (id: number) =>
    ({
      method: "DELETE",
      url: `${management}/project/${id}`,
    }) as Endpoint,
};
